var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.mainWrapperClass }, [
    _c(
      "div",
      { class: _vm.$modal.modalContent },
      [
        _c("v-flex", [
          _c("p", { class: _vm.$modal.modalText }, [
            _vm._v(
              "\n        Enter in your email to receive a password reset link:\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "v-flex",
          { class: [_vm.$modal.modalInput, _vm.$modal.shortInput] },
          [
            _c("InputField", {
              class: ((_obj = {}),
              (_obj[_vm.$modal.errorField] = _vm.$v.email.$error),
              _obj),
              attrs: { label: "Email*", type: "email" },
              on: { input: _vm.onChange },
              model: {
                value: _vm.$v.email.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.email, "$model", $$v)
                },
                expression: "$v.email.$model"
              }
            }),
            _vm._v(" "),
            !_vm.$v.email.required && _vm.$v.email.$error
              ? _c("p", { class: _vm.$modal.errorMessage }, [
                  _vm._v("\n        Email is required\n      ")
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.$v.email.email
              ? _c("p", { class: _vm.$modal.errorMessage }, [
                  _vm._v("\n        Email is invalid\n      ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.errors
              ? _c("p", { class: _vm.$modal.errorMessage }, [
                  _vm._v("\n        " + _vm._s(_vm.errors) + "\n      ")
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.isMobilePlatform
          ? _c(
              "MobileButton",
              {
                class: _vm.$modal.mobileBtn,
                attrs: { disabled: _vm.pending },
                on: { click: _vm.formAction }
              },
              [_vm._v("\n      Submit\n    ")]
            )
          : _c(
              "v-flex",
              { class: _vm.$modal.modalButtons },
              [
                _c(
                  "BaseButton",
                  {
                    class: _vm.$modal.submitBtn,
                    attrs: { "button-style": "Main" },
                    on: { click: _vm.formAction }
                  },
                  [_vm._v("Submit")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: _vm.$modal.cancelBtn,
                    on: {
                      click: function($event) {
                        return _vm.close()
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ],
              1
            )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/auth/components/ForgotPassword.vue?vue&type=template&id=64a13c38&
// module id = null
// module chunks = 